
// ---- Format relative number to string with parenthesis
export function relativeNumberToStringWithParenthesis(relativeNumber) {
    if (relativeNumber > 0) {
        return `(+${relativeNumber})`
    } else {
        return "(" + relativeNumber + ")"
    }
}

// ---- Format relativeDifferenceResult number into string with potential sign
export function relativeDifferenceResultFromNumberToString(relativeDifferenceResult) {
    if (relativeDifferenceResult > 0) {
        // Case : relativeDifferenceResult is positive
        return `+${relativeDifferenceResult}`
    } else if (relativeDifferenceResult === 0) {
        // Case : relativeDifferenceResult is zero
        return "0"
    } else {
        // Case : relativeDifferenceResult is negative
        return relativeDifferenceResult.toString()
    }
}

// ---- Compare userAnswer with current relativeDifference result
export function compareRelativeDifferenceResult(userSign, userAnswer, relativeDifferenceResult) {
    if (typeof userSign !== "string" || typeof userAnswer !== "string" || typeof relativeDifferenceResult !== "number")
        return false
    if (userAnswer === "0")
        return userAnswer === relativeDifferenceResultFromNumberToString(relativeDifferenceResult)
    return (userSign + userAnswer) === relativeDifferenceResultFromNumberToString(relativeDifferenceResult)
}